import { useQuery } from '@tanstack/react-query';
import { type KnowledgeBase } from '@/Domain/api/KnowledgeBase/dto/KnowledgeBase.dto';
import { CenterSpinner } from '@/Domain/components/Shared/CenterSpinner/CenterSpinner';
import { ProfilePage } from '@/UI/Identity/Profile/Profile.page';

export const ProfileLoader = () => {
  const { data: knowledgeBaseData, isLoading } = useQuery<KnowledgeBase>({
    queryKey: ['knowledge_base'],
  });

  if (isLoading) {
    return <CenterSpinner />;
  }

  return <ProfilePage knowledgeBaseData={knowledgeBaseData!} />;
};
